import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { BasePage, PageType } from 'src/components/BasePage';
import { ProcessStartForm } from 'src/components/ProcessStartForm';
import { SpinnerFullWidth } from 'src/components/Spinner/SpinnerFullWidth';
import { RoutePaths } from 'src/core/router/RoutePaths';
import { Router } from 'src/core/router/Router';
import { ProcessStoreProvider } from 'src/stores/ProcessStore/ProcessStore';
import { SettingsNotificationTemplatesStore } from 'src/stores/SettingsStores/SettingsNotificationTemplatesStore/SettingsNotificationTemplatesStore';

export const NotificationProcessPage = observer(() => {
    const { params } = useRouteMatch<{ processKey: string; id: string }>();
    const { id, processKey } = params;

    const process = ProcessStoreProvider.getInstance(processKey);

    const processContext = _.merge(store.currentItem, process.getContext);

    useEffect(() => {
        if (!id) {
            return;
        }
        store.loadItem(id);

        return () => {
            store.itemLoader.reset();
        };
    }, []);

    if (store.itemLoader.isLoading) {
        return <SpinnerFullWidth />;
    }

    return (
        <BasePage
            pageName="notification-templates-process"
            type={PageType.FULL}
            className="container-fluid"
        >
            <ProcessStartForm
                processKey={processKey}
                context={processContext}
                onSubmit={() => {
                    Router.navigate(
                        RoutePaths.settingsNotificationTemplateList,
                    );
                }}
                onCustomEvent={(event) => {
                    if (event.type === 'navigateToEntityCard') {
                        event.event.preventDefault();
                        Router.navigate(
                            RoutePaths.settingsNotificationTemplateList,
                        );
                    }
                }}
            />
        </BasePage>
    );
});

const store = SettingsNotificationTemplatesStore;
